import { FC } from 'react'
import ReactModal from 'react-modal'

import PoapImage from 'components/PoapImage'
//Assets
import { ReactComponent as IconClose } from 'images/icons/close.svg'

import styles from './ImageModal.module.scss'

interface ImageModalProps {
  imageUrl: string
  isOpen: boolean
  onCloseClick: () => void
}

const ImageModal: FC<ImageModalProps> = ({ imageUrl, isOpen, onCloseClick }) => {
  const iconSize = 24
  return (
    <ReactModal
      className={styles.imageModal}
      isOpen={isOpen}
      onRequestClose={onCloseClick}
      shouldFocusAfterRender={false}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
    >
      <i className={styles.iconContainer}>
        <IconClose className={styles.iconClose} width={iconSize} height={iconSize} onClick={onCloseClick} />
      </i>
      <PoapImage className={styles.image} src={imageUrl} alt="Drop" width="500" height="500" />
    </ReactModal>
  )
}

export default ImageModal
